export const space = (state) => state.classRoom;
export const spacesData = (state) => state.data.classRooms;

export const current = (classRoom) => classRoom.current;

const sortedByName = ({ name: nameA }, { name: nameB }) => {
  const lowerA = nameA.toLowerCase();
  const lowerB = nameB.toLowerCase();
  if (lowerA < lowerB) return -1;
  if (lowerA > lowerB) return 1;
  return 0;
};

export const alphabeticallySorted = (classRooms) =>
  Object.values(classRooms).sort(sortedByName);

export const spaceById = (spaces, spaceId) => (spaces ? spaces[spaceId] : null);

export const spaceByPropsId = (state, props) =>
  spaceById(spacesData(state), props.spaceId);

export const initialSpaceId = (state) => {
  const spaces = alphabeticallySorted(spacesData(state));
  const firstNonArchived = spaces.find((s) => !s.archived);
  const selectedSpace = firstNonArchived || spaces[0];
  return selectedSpace ? selectedSpace.objectId : null;
};
